// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","791":"video"}[chunkId] + "." + {"443":"6a55001f","791":"34b49a71"}[chunkId] + ".js";
};